"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrFooterHeading = exports.FdrROCContent = exports.FdrROCWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.FdrROCWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    borderRadius: ['roundedTop', '0px'],
    px: [4, '70px'],
    pt: [4, '40px'],
    pb: [0, '30px'],
    flexBasis: [null, '50%'],
    mr: [null, 4],
    backgroundColor: 'background',
    boxShadow: ['none', 'blockShadow'],
}));
exports.FdrROCContent = styled_components_1.default.div(({ theme, theme: { space, media, fontSizes } }) => ({
    marginBottom: space[3],
    listStyle: 'none',
    [media.tablet]: {
        marginBottom: 0,
    },
    li: {
        paddingLeft: '30px',
        marginBottom: space[2],
        position: 'relative',
        '&:before': {
            content: '""',
            position: 'absolute',
            color: 'black',
            left: 0,
            top: '3px',
            width: '20px',
            height: '20px',
            backgroundImage: 'url("/images/svg/Success.svg")',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            [media.tablet]: {
                top: space[1],
                width: '25px',
                height: '25px',
            },
        },
        [media.tablet]: {
            paddingLeft: '35px',
            fontSize: fontSizes[3],
        },
    },
    p: {
        marginBottom: space[1],
        [media.tablet]: {
            marginBottom: space[2],
        },
    },
    a: theme.link.text,
}));
exports.FdrFooterHeading = styled_components_1.default.h3(({ theme }) => theme.footer.heading);
//# sourceMappingURL=fdr-footer.styles.js.map